export default class ValidateLength {
   length;
   emptyFine;
   errMsg;

   constructor(length = 0, emptyFine = false) {
      this.length    = length;
      this.emptyFine = emptyFine;
   }

   validate(value) {
      if (this.emptyFine === true && value.length == 0) return true;

      if (value.length != this.length) return this.setErr();
      else return true;

   }
   
   setErr() {
      this.errMsg =  ['lang_has_to_be', this.length,'lang_characters'];
      return this.errMsg;
   }

}